














































































import { Prop, Component, Vue } from "vue-property-decorator";
import VDelete from "@/components/VDelete.vue";
import SelectOption from "@/common/ui/presenters/select-option";
import { ServiceRole } from "@/api/service-api";
import TaskType from "@/entities/task-type";
import { Company } from "../api/company-api";
import EditStaffResponse from "../usecases/responses/edit-staff-response";
import TaskTypeNewModal from "@/views/TaskTypeNewModal.vue";
import SwitchButton from "@/components/SwitchButton.vue";
import ErrorAlert from "@/components/ErrorAlert.vue";

@Component({
  components: {
    VDelete,
    TaskTypeNewModal,
    SwitchButton,
    ErrorAlert
  },
  props: {
    removable: {
      type: Boolean,
      default: false
    },
    errors: {
      type: [],
      default: []
    }
  }
})
export default class StaffEdit extends Vue {
  @Prop({ required: true }) req!: EditStaffResponse;
  @Prop({ default: () => [] }) companies!: Company[];
  @Prop({ default: () => [] }) roles!: ServiceRole[];
  @Prop({ default: () => [] }) tasktypes!: TaskType[];
  @Prop({ type: Boolean }) companyEditable!: boolean;

  get workOptions(): SelectOption[] {
    return this.tasktypes.map(t => ({
      text: t.name,
      value: String(t.id)
    }));
  }

  get companyOptions(): SelectOption[] {
    return this.companies.map(c => ({
      text: c.name,
      value: c.office.officeId
    }));
  }

  get roleOptions(): SelectOption[] {
    return this.roles.map(r => ({
      text: r.name,
      value: r.id
    }));
  }

  get contentDeleteStaff() {
    return this.req.hasTaskSub
      ? "タスクがあります。他の担当者を割り振りますか？"
      : "本当に削除しますか？";
  }

  status = "";

  submit(e: MouseEvent) {
    this.status = "progressing";
    this.$emit("ok", e);
    this.status = "";
  }

  cancel(e: MouseEvent) {
    this.$emit("cancel", e);
  }

  // Handle hidden info

  handleClickHiddenInfo(isHiddenInfo: number) {
    this.req.isHiddenInfo = isHiddenInfo === 0 ? 1 : 0;
  }
}
